import { Auth0Client, Auth0ClientOptions, createAuth0Client } from "@auth0/auth0-spa-js";
import { loadStoredOrFetchConfiguration } from "@newsenec/configuration-provider";

let auth0Client: Auth0Client | undefined;

/** Returns the default auth0 client.*/
export async function getAuthClient() {
    if (!auth0Client) {
        auth0Client = await createAuthClient();
    }
    return auth0Client;
}

const prodEnv = "prod";
function isProd(env: string): boolean {
    const envSplit = env.split(",").map((value) => value.trim());
    return envSplit.includes(prodEnv);
}

/**
 * Creates auth0 client
 * @param viewsignup boolean
 * indicating if MEK registration page should be shown for loginWithRedirect
 * (default is MEK login page )
 *
 * @returns auth0 client
 */
export async function createAuthClient(viewsignup = false) {
    const config = await loadStoredOrFetchConfiguration();
    const options: Auth0ClientOptions = isProd(config.environment)
        ? {
              authorizationParams: {
                  audience: "https://pro-login.enbw.com/",
                  redirect_uri: new URL(window.location.href).origin,
                  scope: "email profile read:bsr:senec-meinSENEC",
                  custom_scope: "email profile read:bsr:senec-meinSENEC",
                  viewsignup,
              },
              cacheLocation: "localstorage",
              clientId: "EQU0ntseSHMYFwPDJSvna6Q1pPaKgWh5",
              domain: "myenergykey.com",
              useRefreshTokens: true,
          }
        : {
              authorizationParams: {
                  audience: "https://qas-login.enbw.com/",
                  redirect_uri: new URL(window.location.href).origin,
                  scope: "email profile read:bsr:senec-meinSENEC",
                  custom_scope: "email profile read:bsr:senec-meinSENEC",
                  viewsignup,
              },
              cacheLocation: "localstorage",
              clientId: "5dVC9DOQY2oPztoozVcwmiRK5wI6mxwA",
              domain: "qas-login.enbw.com",
              useRefreshTokens: true,
          };
    return createAuth0Client(options);
}
